"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newForRent = exports.estate = exports.defaultResultPageState = exports.defaultResultPageTranslate = exports.forSaleOnly = exports.forRentOnly = exports.defaultSoldItem = exports.defaultResultItemsWithAgent = exports.defaultResultItems = exports.defaultPropertyEnquiryAnalyticActions = exports.defaultAddFavouriteAnalyticActions = exports.defaultResultItemBannersSold = exports.defaultResultItemBanners3 = exports.defaultResultItemBanners2 = exports.defaultResultItemBanners = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
var SactionState_1 = require("@/pages/search/states/SactionState");
exports.defaultResultItemBanners = [
    {
        label: 'Break Lease',
        labelColour: '#fff',
        bannerType: ResultPageState_1.ResultItemBannerType.Primary,
        bannerColour: '#bc9408',
    },
];
exports.defaultResultItemBanners2 = [
    {
        label: 'Sole Agent',
        labelColour: '#fff',
        bannerType: ResultPageState_1.ResultItemBannerType.Primary,
        bannerColour: '#bc9408',
    },
];
exports.defaultResultItemBanners3 = [
    {
        label: 'Joint Sole Agent',
        labelColour: '#fff',
        bannerType: ResultPageState_1.ResultItemBannerType.Primary,
        bannerColour: '#bc9408',
    },
];
exports.defaultResultItemBannersSold = [
    {
        label: 'Sold',
        labelColour: '#fff',
        bannerType: ResultPageState_1.ResultItemBannerType.Primary,
        bannerColour: '#000',
    },
];
exports.defaultAddFavouriteAnalyticActions = {
    facebook: {
        facebookPixels: [{
                event: 'track',
                action: 'InitiateCheckout',
                eventJson: '{ "test": 1 }',
            }],
    },
};
exports.defaultPropertyEnquiryAnalyticActions = {
    facebook: {
        facebookPixels: [{
                event: 'track',
                action: 'Purchase',
                eventJson: '{ "test": 1 }',
            }],
    },
};
exports.defaultResultItems = [
    {
        price: 35000000,
        salePrice: 35000000,
        leasePrice: 90000,
        size: 1516,
        pricePerSqft: 60,
        salePricePerSqft: 23087,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 23087,
        leasePricePerSqft: 60,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 60,
        images: [
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927569691764.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927604635825.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
            {
                key: 'terrace',
                value: 1,
                displayKey: 'Terrace',
                displayValue: '1 TR',
            },
        ],
        isSoleAgent: true,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Victoria Court',
        area: 'Discovery Bay',
        address: '50-56 Hing Fat Street',
        type: SfilterTypeGroup_1.SfilterType.BUYRENT,
        sizeGross: 2100,
        sizeSaleable: 1516,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        isVirtual: true,
        isVideo: true,
        lastUpdated: new Date('2019-05-19T00:00:00'),
        referenceId: 367009,
        lat: 22.2812449,
        lng: 114.1565716,
        banners: exports.defaultResultItemBanners,
    },
    {
        price: 0,
        salePrice: 0,
        leasePrice: 0,
        size: 443,
        pricePerSqft: 0,
        salePricePerSqft: 0,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 0,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 0,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/367007_636651860047781168.jpg',
                caption: 'Property Photo',
            }
        ],
        amenities: [
            {
                key: 'bed',
                value: 1,
                displayKey: 'Bedrooms',
                displayValue: '1 BD',
            },
            {
                key: 'bath',
                value: 1,
                displayKey: 'Bathroom',
                displayValue: '1 BA',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: "95-97 Queen's Road East",
        area: 'Hong Kong Island',
        districtId: 0,
        address: "95-97 Queen's Road East",
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 0,
        sizeSaleable: 443,
        isSaved: false,
        isVirtual: true,
        isVideo: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-20T16:00:00.000Z'),
        referenceId: 367007,
        lat: 40.718217,
        lng: -73.998284,
        isSaleSubjectToOffer: true,
        isSubjectToOffer: true,
    },
    {
        price: 23500,
        salePrice: 0,
        leasePrice: 23500,
        size: 501,
        pricePerSqft: 60,
        salePricePerSqft: 0,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 46.9,
        leasePricePerSqftGross: 36.7,
        leasePricePerSqftSaleable: 46.9,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/366994_636647526034989583.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/366994_636655224479917728.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
            {
                key: 'roof',
                value: 1,
                displayKey: 'Rooftop',
                displayValue: '1 RF',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Bailey Garden',
        area: 'Kowloon',
        districtId: 0,
        address: '23 Bailey Street',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 639,
        sizeSaleable: 501,
        isSaved: false,
        isVirtual: false,
        isVideo: true,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-22T16:00:00.000Z'),
        referenceId: 366994,
        lat: 40.718217,
        lng: -73.998284,
    },
    {
        price: 25200,
        salePrice: 0,
        leasePrice: 25200,
        size: 540,
        pricePerSqft: 60,
        salePricePerSqft: 0,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 46.6,
        leasePricePerSqftGross: 35.8,
        leasePricePerSqftSaleable: 46.6,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/367003_636651135221368078.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367003_636651135253660135.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 1,
                displayKey: 'Bathroom',
                displayValue: '1 BA',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Maple Gardens',
        area: 'Hong Kong Island',
        districtId: 0,
        address: '51 Kin Wah Street',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 703,
        sizeSaleable: 540,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-21T16:00:00.000Z'),
        referenceId: 367003,
        lat: 40.718217,
        lng: -73.998284,
    },
    {
        price: 4500000,
        salePrice: 4500000,
        leasePrice: 90000,
        pricePerSqft: 60,
        salePricePerSqft: 23087,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 23087,
        leasePricePerSqft: 60,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 60,
        size: 2100,
        images: [
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927569691764.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927604635825.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 2,
                displayKey: 'Balcony',
                displayValue: '2 BL',
            },
            {
                key: 'terrace',
                value: 1,
                displayKey: 'Terrace',
                displayValue: '1 GD',
            },
            {
                key: 'garden',
                value: 1,
                displayKey: 'Garden',
                displayValue: '1 GD',
            },
            {
                key: 'roof',
                value: 1,
                displayKey: 'Rooftop',
                displayValue: '1 RF',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.UNKNOWN,
        building: 'Nam Shan',
        area: 'New Territories',
        districtId: 0,
        address: ' Nam Shan',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 2100,
        sizeSaleable: 0,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-22T16:00:00.000Z'),
        referenceId: 367019,
        lat: 40.718217,
        lng: -73.998284,
    },
    {
        price: 6500000,
        salePrice: 6500000,
        leasePrice: 90000,
        size: 834,
        pricePerSqft: 60,
        salePricePerSqft: 7739.7,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 7739.7,
        leasePricePerSqft: 107.9,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 107.9,
        images: [
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927569691764.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927604635825.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Hennessy Building',
        area: 'Hong Kong Island',
        districtId: 0,
        address: '117-123 Hennessy Road',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 0,
        sizeSaleable: 834,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-21T16:00:00.000Z'),
        referenceId: 367012,
        lat: 40.718217,
        lng: -73.998284,
    },
    {
        price: 3500000,
        salePrice: 3500000,
        leasePrice: 90000,
        size: 374,
        pricePerSqft: 60,
        salePricePerSqft: 9358,
        salePricePerSqftGross: 7478,
        salePricePerSqftSaleable: 9358,
        leasePricePerSqft: 240.6,
        leasePricePerSqftGross: 192.3,
        leasePricePerSqftSaleable: 240.6,
        images: [
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927569691764.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927604635825.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 1,
                displayKey: 'Bedrooms',
                displayValue: '1 BD',
            },
            {
                key: 'bath',
                value: 1,
                displayKey: 'Bathroom',
                displayValue: '1 BA',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Shan Tsui Court',
        area: 'Hong Kong Island',
        districtId: 0,
        address: '200 Tai Tam Road',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 468,
        sizeSaleable: 374,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-20T16:00:00.000Z'),
        referenceId: 367011,
        lat: 40.718217,
        lng: -73.998284,
    },
    {
        price: 3500000,
        salePrice: 3500000,
        leasePrice: 90000,
        size: 1260,
        pricePerSqft: 27777,
        salePricePerSqft: 27777,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 27777,
        leasePricePerSqft: 71.4,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 71.4,
        images: [
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927569691764.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927604635825.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 4,
                displayKey: 'Bedrooms',
                displayValue: '4 BD',
            },
            {
                key: 'bath',
                value: 3,
                displayKey: 'Bathroom',
                displayValue: '3 BA',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Eden Gate',
        area: 'Kowloon',
        districtId: 0,
        address: '11 Ede Road',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 0,
        sizeSaleable: 1260,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-18T16:00:00.000Z'),
        referenceId: 367000,
        lat: 40.718217,
        lng: -73.998284,
        isRelated: true,
        isVirtual: false,
    },
    {
        price: 32000,
        salePrice: 3500000,
        leasePrice: 32000,
        size: 376,
        pricePerSqft: 9308,
        salePricePerSqft: 9308,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 9308,
        leasePricePerSqft: 0,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 0,
        images: [
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927569691764.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927604635825.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 2,
                displayKey: 'Bedrooms',
                displayValue: '2 BD',
            },
            {
                key: 'bath',
                value: 1,
                displayKey: 'Bathroom',
                displayValue: '1 BA',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Everwin Mansion',
        area: 'Hong Kong Island',
        districtId: 0,
        address: '18 Johnston Road',
        type: SfilterTypeGroup_1.SfilterType.BUYRENT,
        sizeGross: 0,
        sizeSaleable: 376,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-13T16:00:00.000Z'),
        referenceId: 366982,
        lat: 40.718217,
        lng: -73.998284,
        isRelated: true,
        isVirtual: false,
    },
];
exports.defaultResultItemsWithAgent = exports.defaultResultItems.map(function (it) { return (__assign(__assign({}, it), { agentImage: 'https://images.okay.com/AgentThumbnail/Source/581_636663148845061393.jpg', agentName: 'Roy Cheung' })); });
exports.defaultSoldItem = __assign(__assign({}, exports.defaultResultItems[0]), { images: exports.defaultResultItems[0].images.slice(0, 1), banners: exports.defaultResultItemBannersSold });
exports.forRentOnly = [
    {
        price: 90000,
        salePrice: 0,
        leasePrice: 90000,
        size: 1516,
        pricePerSqft: 60,
        salePricePerSqft: 0,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 60,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 60,
        images: [
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927569691764.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927604635825.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
        ],
        isSoleAgent: true,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Victoria Court',
        area: 'Hong Kong Island',
        districtId: 0,
        address: '50-56 Hing Fat Street',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 0,
        sizeSaleable: 1516,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-20T16:00:00.000Z'),
        referenceId: 367009,
        lat: 40.718217,
        lng: -73.998284,
    },
    {
        price: 0,
        salePrice: 0,
        leasePrice: 0,
        size: 443,
        pricePerSqft: 0,
        salePricePerSqft: 0,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 0,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 0,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/367007_636651860047781168.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367007_636651860118137292.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 1,
                displayKey: 'Bedrooms',
                displayValue: '1 BD',
            },
            {
                key: 'bath',
                value: 1,
                displayKey: 'Bathroom',
                displayValue: '1 BA',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: "95-97 Queen's Road East",
        area: 'Hong Kong Island',
        districtId: 0,
        address: "95-97 Queen's Road East",
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 0,
        sizeSaleable: 443,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-20T16:00:00.000Z'),
        referenceId: 367007,
        lat: 40.718217,
        lng: -73.998284,
        isSaleSubjectToOffer: false,
        isLeaseSubjectToOffer: true,
        isSubjectToOffer: true,
    },
    {
        price: 23500,
        salePrice: 0,
        leasePrice: 23500,
        size: 501,
        pricePerSqft: 60,
        salePricePerSqft: 0,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 0,
        leasePricePerSqft: 46.9,
        leasePricePerSqftGross: 36.7,
        leasePricePerSqftSaleable: 46.9,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/366994_636647526034989583.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/366994_636655224479917728.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
            {
                key: 'roof',
                value: 1,
                displayKey: 'Rooftop',
                displayValue: '1 RF',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Bailey Garden',
        area: 'Kowloon',
        districtId: 0,
        address: '23 Bailey Street',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 639,
        sizeSaleable: 501,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-22T16:00:00.000Z'),
        referenceId: 366994,
        lat: 40.718217,
        lng: -73.998284,
    },
];
exports.forSaleOnly = [
    {
        price: 35000000,
        salePrice: 35000000,
        leasePrice: 0,
        size: 1516,
        pricePerSqft: 23087,
        salePricePerSqft: 23087,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 23087,
        leasePricePerSqft: 0,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 0,
        images: [
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927569691764.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367009_636651927604635825.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Building/Original/1210_635315108080946337.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
        ],
        isSoleAgent: true,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Victoria Court',
        area: 'Hong Kong Island',
        districtId: 0,
        address: '50-56 Hing Fat Street',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 0,
        sizeSaleable: 1516,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-20T16:00:00.000Z'),
        referenceId: 367009,
        lat: 40.718217,
        lng: -73.998284,
    },
    {
        price: 3500000,
        salePrice: 3500000,
        leasePrice: 0,
        size: 443,
        pricePerSqft: 23087,
        salePricePerSqft: 23087,
        salePricePerSqftGross: 0,
        salePricePerSqftSaleable: 23087,
        leasePricePerSqft: 0,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 0,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/367007_636651860047781168.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/367007_636651860118137292.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 1,
                displayKey: 'Bedrooms',
                displayValue: '1 BD',
            },
            {
                key: 'bath',
                value: 1,
                displayKey: 'Bathroom',
                displayValue: '1 BA',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: "95-97 Queen's Road East",
        area: 'Hong Kong Island',
        districtId: 0,
        address: "95-97 Queen's Road East",
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 0,
        sizeSaleable: 443,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-20T16:00:00.000Z'),
        referenceId: 367007,
        lat: 40.718217,
        lng: -73.998284,
    },
    {
        price: 23452312,
        salePrice: 23452312,
        leasePrice: 0,
        size: 501,
        pricePerSqft: 14599,
        salePricePerSqft: 14599,
        salePricePerSqftGross: 9599,
        salePricePerSqftSaleable: 14599,
        leasePricePerSqft: 0,
        leasePricePerSqftGross: 0,
        leasePricePerSqftSaleable: 0,
        images: [
            {
                path: 'https://images.okay.com/Property/Folder150/366994_636647526034989583.jpg',
                caption: 'Property Photo',
            },
            {
                path: 'https://images.okay.com/Property/Folder150/366994_636655224479917728.jpg',
                caption: 'Property Photo',
            },
        ],
        amenities: [
            {
                key: 'bed',
                value: 3,
                displayKey: 'Bedrooms',
                displayValue: '3 BD',
            },
            {
                key: 'bath',
                value: 2,
                displayKey: 'Bathroom',
                displayValue: '2 BA',
            },
            {
                key: 'maid',
                value: 1,
                displayKey: "Maid's Room",
                displayValue: '1 MR',
            },
            {
                key: 'balcony',
                value: 1,
                displayKey: 'Balcony',
                displayValue: '1 BL',
            },
            {
                key: 'roof',
                value: 1,
                displayKey: 'Rooftop',
                displayValue: '1 RF',
            },
        ],
        isSoleAgent: false,
        isJointSoleAgent: false,
        includeManagementFee: ResultPageState_1.ResultIncludeManagementFee.INCLUDE,
        building: 'Bailey Garden',
        area: 'Kowloon',
        districtId: 0,
        address: '23 Bailey Street',
        type: SfilterTypeGroup_1.SfilterType.RENT,
        sizeGross: 639,
        sizeSaleable: 501,
        isSaved: false,
        buildingAge: -1,
        floor: 'High',
        isSaving: false,
        lastUpdated: new Date('2018-06-22T16:00:00.000Z'),
        referenceId: 366994,
        lat: 40.718217,
        lng: -73.998284,
    },
];
exports.defaultResultPageTranslate = {
    showing: 'Showing Page',
    sole: 'Sole Agent',
    jointSole: 'Joint Sole Agent',
    sqft: 'SF',
    gross: 'G',
    saleable: 'S',
    lastUpdated: 'Updated',
    size: 'Size',
    floor: 'Floor',
    ref: 'Ref',
    prev: 'Prev',
    next: 'Next',
    noPhoto: 'No Photo',
    age: 'Age',
    year: 'YR',
    emptyTitle: 'No Properties matches this criteria',
    emptyCaption: 'Try a less strict filter to have better results',
    emptyStartNew: '',
    emptySearchNow: 'Start a new Search',
    bedrooms: 'Bedrooms',
    bd: 'BD',
    bathrooms: 'Bathrooms',
    ba: 'BA',
    maidsroom: "Maid'sRoom ",
    mr: 'MR',
    save: 'Save',
    streetNumber: '',
    similarText: 'Similar properties related to your search results',
    include: 'incl.',
    exclude: 'excl.',
    backToPageOne: 'Back to Page 1',
    loading: 'Loading',
    loadmore: 'Load More',
    contact: 'Contact',
    saveThisSearch: 'Save this Search',
    saveThisSearchCaption: 'Get our super-secret email updates and be the first to know about new homes and price changes!​',
    stillThinking: "Don't Miss Out!",
    subjectToOffer: 'Subject to Offer',
    offMarket: 'Not Available',
    buy: 'For Sale',
    rent: 'For Rent',
    buyrent: 'For Sale and Rent',
    photo: 'Photo',
    edit: 'Edit',
    remove: 'Remove',
    unit: 'Unit',
    units: 'Units',
    clearBoundary: 'Clear Map Boundary',
    trendsOfEstate: 'Trends of Estate',
    persf: '/ SF',
    viewMore: 'View More',
    emptyTitleViewportOutOfDistrict: 'The map is out of your selected districts',
    emptyCaptionViewportOutOfDistrict: 'Click to remove selected districts from the filter',
    clearDistrict: 'Clear Districts Filter',
    backToDistrict: 'Back to previous districts',
};
exports.defaultResultPageState = {
    t: exports.defaultResultPageTranslate,
    view: SactionState_1.SactionView.GRID,
    lastItemPosition: 0,
    isLoading: false,
    isFavLoading: false,
    isInfiniteLoadEnabled: true,
    resultResponses: [{
            page: 1,
            pageTotal: 10,
            results: exports.defaultResultItems,
            sliderInit: false,
            resultTotal: 90,
            heading: '2,494 Properties for rent in Hong Kong',
        }],
    pageSize: 24,
    currentUrl: '',
};
exports.estate = {
    estateImage: 'https://images.okay.com/Property/HQ/regent-height-western-district-for-sale-212778_637292860890865590.jpg',
    estatePpsf: 23456,
    estateIsSa: true,
    estateName: 'South Horizons',
    estateAddress: '1 South Horizons Drive, Aberdeen, Hong Kong',
    estateUrl: '#estate',
};
exports.newForRent = __spreadArrays([
    __assign(__assign({}, exports.forRentOnly[0]), { lastUpdated: '51 hours ago' })
], exports.forRentOnly.slice(1));
